import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  alert,
  float,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  required,
  Select,
  Pagination,
  Switch,
  Navbar,
  Modal,
  linkRole,
  copyText,
  CopyCell,
} from "../../components/CustomComponent.js";

// ---------------------------------------------------------------------------
// Presentation-only constants. The business logic (Get / CreateUpdate /
// ResendVerification / Delete) and every state field name are unchanged from
// the previous version of this page, only the layout is new.
// ---------------------------------------------------------------------------
const USER_TYPE_FILTER_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "agent", label: "Agent" },
  { value: "broker", label: "Broker" },
  { value: "sub_broker", label: "Sub Broker" },
];
const USER_TYPE_FORM_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "admin_broker", label: "Admin Broker" },
  { value: "broker", label: "Broker" },
  { value: "sub_broker", label: "Sub Broker" },
  { value: "agent", label: "Agent" },
  { value: "accounting", label: "Accounting" },
];
// Same label / colour mapping as before, just table-driven.
const USER_TYPE_META = {
  admin: { label: "admin", color: "success" },
  agent: { label: "agent", color: "info" },
  broker: { label: "broker", color: "purple" },
  sub_broker: { label: "sub broker", color: "primary" },
  accounting: { label: "accounting", color: "warning" },
};
// Gold-accented toggle to match the premium theme.
const SWITCH_PROPS = {
  onColor: "#c9a23a",
  offColor: "#cbd5e1",
  onHandleColor: "#ffffff",
  checkedIcon: false,
  uncheckedIcon: false,
  height: 22,
  width: 42,
  handleDiameter: 16,
  activeBoxShadow: "0 0 0 3px rgba(212, 175, 55, 0.3)",
};

export default class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_user_type: "",
      filter_broker_id: "",

      loaded: false,
      data: [],
      count: 10,
      data_role: [],
      data_broker: [],

      id: "",
      uid: "",
      full_name: "",
      phone: "",
      role_id: "",
      email: "",
      password: "",
      is_active: false,
      is_2fa: false,
      is_mismatch_limit_approved: false,
      broker_id: "",

      user_type: "",
    };
  }

  async componentDidMount() {
    loading(false);
    // master data (role / broker) ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
    // ของเดิมดึงใหม่ทุกครั้งที่ค้นหาหรือเปลี่ยนหน้า ทั้งที่ขอมาทีละแสนแถว
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_role, data_broker;
    let [result_role, result_broker] = await Promise.all([
      GET("v1/admin/roles", { page_size: 100000, page: 0, data_search: "" }),
      GET("v1/admin/brokers/options", {
        page_size: 100000,
        page: 0,
        data_search: "",
      }),
    ]);
    if (result_role?.status) {
      data_role = result_role.data;
    }
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
      }));
    }
    this.setState({ data_role, data_broker });
  };
  Get = async (page) => {
    let data, count;
    loading(true);
    let result = await GET("v1/admin/users", {
      page_size: 10,
      page: page,
      data_search: this.state.filter_search,
      user_type: this.state.filter_user_type,
      broker_id: this.state.filter_broker_id,
    });
    if (result?.status) {
      data = result.data;
      count = result.pagination?.count ?? 0;
    }
    this.setState({
      loaded: true,
      data,
      count,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      modal_create,
      uid,
      full_name,
      phone,
      role_id,
      email,
      password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      user_type,
      broker_id,
    } = this.state;
    if (!full_name.trim()) {
      alert("", "warning", "Warning", "Please input Name");
      return;
    } else if (!role_id.trim()) {
      alert("", "warning", "Warning", "Please select Role");
      return;
    } else if (!email.trim()) {
      alert("", "warning", "Warning", "Please input Email");
      return;
    }
    if (modal_create) {
      if (!password) {
        alert("", "warning", "Warning", "Please input Password");
        return;
      }
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        full_name,
        phone,
        role_id,
        email,
        user_type: user_type.replaceAll(" ", "_"),
        password,
        is_active,
        is_2fa,
        is_mismatch_limit_approved,
        broker_id: broker_id || null,
      };

      let result = !uid
        ? await POST("v1/admin/users", body)
        : await PUT("v1/admin/users/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  ResendVerification = async (uid) => {
    if (!uid?.trim()) {
      alert("", "warning", "Warning", "Please select a user");
      return;
    }
    loading(true);
    // ยืนยันสิทธิ์ด้วย session แอดมิน (checkAuth + checkPermission) ไม่ใช้ captcha/master token แล้ว
    let result = await POST("v1/admin/users/" + uid + "/resend-verification", {});
    if (result?.status) {
      alert(
        "#",
        "success",
        "Success",
        "We've sent a verification link to your email"
      );
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await DELETE("v1/admin/users/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };

  // -------------------------------------------------------------------------
  // Render helpers (presentation only)
  // -------------------------------------------------------------------------
  openCreate = () => {
    this.setState({
      id: "",
      uid: "",
      full_name: "",
      phone: "",
      role_id: "",
      email: "",
      password: "",
      user_type: "",
      broker_id: "",
      is_active: true,
      is_2fa: false,
      is_mismatch_limit_approved: false,
      modal_create: true,
    });
  };
  openUpdate = (item) => {
    this.setState({
      ...item,
      role_id: item.role?.uid || "",
      broker_id: item.broker?.uid || "",
      modal_update: true,
    });
  };
  closeModal = () => {
    this.setState({ modal_create: false, modal_update: false });
  };
  renderTypeChip = (user_type) => {
    const meta = USER_TYPE_META[user_type];
    return meta
      ? Status(meta.label, meta.color)
      : Status((user_type || "-").replaceAll("_", " "), "danger");
  };
  renderRow = (item, index) => {
    const brokerName = item.broker?.name_en || item.broker?.name_th || "";
    return (
      <tr key={item.uid || `array-${index}`}>
        <td data-label="Code" className="text-nowrap">
          <div className="pu-uid">
            {item.user_code ? <CopyCell value={item.user_code} className="pu-shq-ref" duration={2000} /> : <span className="pu-none">-</span>}
          </div>
        </td>
        <td data-label="Name" className="text-nowrap">
          <div className="pu-user">
            <div className="min-w-0">
              <div className="pu-name text-truncate" title={item.full_name}>
                {item.full_name || "-"}
              </div>
              {item.broker ? (
                <div className="pu-sub">
                  <span className="icon me-1">{""}</span>
                  <span className="text-truncate">{brokerName}</span>
                  <span
                    className="icon pu-link ms-1 pointer"
                    title="Open broker"
                    onClick={() => {
                      window.location.href = `/${linkRole(
                        profile?.user_type
                      )}/brokers?search=${brokerName}`;
                    }}
                  >
                    {""}
                  </span>
                </div>
              ) : (
                item.phone && (
                  <div className="pu-sub">
                    <span className="icon me-1">{""}</span>
                    {item.phone}
                  </div>
                )
              )}
            </div>
          </div>
        </td>
        <td data-label="Email" className="text-nowrap">
          <div className="pu-email" title={item.email}>
            {item.email ? <CopyCell value={item.email} className="pu-shq-ref" duration={2000} /> : <span className="pu-none">-</span>}
          </div>
          {!item.is_verify && (
            <span className="pu-tag">
              <span className="icon me-1">{""}</span>Awaiting verification
            </span>
          )}
        </td>
        <td data-label="Type" className="text-nowrap">
          <div className="d-flex align-items-center justify-content-center">
            {this.renderTypeChip(item.user_type)}
          </div>
        </td>
        <td data-label="Status" className="text-nowrap text-center">
          <span className={`pr-status ${item.is_active ? "on" : "off"}`}>
            {item.is_active ? "Active" : "Inactive"}
          </span>
        </td>
        <td data-label="2FA" className="text-nowrap text-center">
          <span
            className={`pu-flag ${item.is_2fa ? "on" : ""}`}
            title={item.is_2fa ? "2FA enabled" : "2FA disabled"}
          >
            <span className="icon">{item.is_2fa ? "" : ""}</span>
            {item.is_2fa ? "Enabled" : "Disabled"}
          </span>
        </td>
        <td data-label="Mismatch AP" className="text-nowrap text-center">
          <span
            className={`pu-flag ${item.is_mismatch_limit_approved ? "on" : ""}`}
            title={
              item.is_mismatch_limit_approved
                ? "Can approve mismatch over 3,500 THB"
                : "Cannot approve mismatch over 3,500 THB"
            }
          >
            <span className="icon">
              {item.is_mismatch_limit_approved ? "" : ""}
            </span>
            {item.is_mismatch_limit_approved ? "Allow" : "Not allow"}
          </span>
        </td>
        <td data-label="Actions" className="text-center users.update td-actions">
          <Dropdown align="end">
            <Dropdown.Toggle className="pu-action-toggle" id={`user-actions-${item.uid}`}>Action</Dropdown.Toggle>
            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
              <Dropdown.Item className="pu-action-item users.update" onClick={() => this.openUpdate(item)}>
                <span className="icon">{""}</span>Update
              </Dropdown.Item>
              {!item.is_verify && (
                <Dropdown.Item
                  data-testid="btn-resend-verification"
                  className="pu-action-item"
                  onClick={async () => {
                  if (
                    await alert(
                      "",
                      "info",
                      "Confirm",
                      "Do you want to send verification to this user?",
                      "Confirm",
                      "Cancel"
                    )
                  ) {
                    this.ResendVerification(item.uid);
                  }
                }}
                >
                  <span className="icon">{""}</span>Resend verification email
                </Dropdown.Item>
              )}
              {!item.is_active && profile?.user_type === "super_user" && (
                <>
                  <div className="pu-action-sep" />
                  <Dropdown.Item className="pu-action-item danger users.delete" onClick={() => this.Delete(item.uid)}>
                    <span className="icon">{""}</span>Delete
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };
  renderToggle = ({ icon, title, desc, checked, onChange }) => (
    <label className={`pu-toggle ${checked ? "on" : ""}`}>
      <span className="pu-toggle-icon icon">{icon}</span>
      <span className="flex-grow-1 min-w-0">
        <span className="pu-toggle-title">{title}</span>
        <span className="pu-toggle-desc">{desc}</span>
      </span>
      <Switch {...SWITCH_PROPS} onChange={onChange} checked={checked} />
    </label>
  );

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_user_type,
      filter_broker_id,
      loaded,
      data,
      count,
      data_role,
      data_broker,
      full_name,
      phone,
      role_id,
      email,
      password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      broker_id,
      user_type,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const showPassword = modal_create || profile?.user_type === "super_user";
    const showBroker = user_type === "sub_broker" || user_type === "broker";
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Access &amp; System</div>
                <div className="ar-title">User Management</div>
                <div className="ar-subtitle">
                  Manage user accounts, roles and security preferences across
                  every workspace.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold users.create"
                  onClick={this.openCreate}
                >
                  <span className="icon me-2">{""}</span>Create User
                </button>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search name, email, code..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">User Type</span>
                <Select
                  className="form-control"
                  placeholder="All user types"
                  options={[
                    { value: "", label: "All user types" },
                    ...USER_TYPE_FILTER_OPTIONS,
                  ]}
                  onChange={(v) => {
                    this.setState({ filter_user_type: v });
                  }}
                  value={filter_user_type}
                  default={false}
                />
                </div>
                {/* เลือก broker แล้วเหลือเฉพาะ user ที่ผูกกับ broker เจ้านั้น
                    ตัวเลือกใช้ชุดเดียวกับ dropdown ในโมดัลสร้าง/แก้ไข user */}
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Broker</span>
                <Select
                  className="form-control"
                  placeholder="All brokers"
                  options={[
                    { value: "", label: "All brokers" },
                    ...(data_broker || []),
                  ]}
                  onChange={(v) => {
                    this.setState({ filter_broker_id: v }, () => this.Get(1));
                  }}
                  value={filter_broker_id}
                  default={false}
                />
                </div>
              <div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() =>
                  this.setState(
                    {
                      filter_search: "",
                      filter_user_type: "",
                      filter_broker_id: "",
                    },
                    () => this.Get(1)
                  )
                }
              >
                Reset
              </button>
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Users
                </div>
                <div className="ar-table-caption">
                  {count || 0} account{count === 1 ? "" : "s"} · showing{" "}
                  {rows.length} on this page
                </div>
              </div>
              <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <span className="pu-legend-dot on" />
                  Active
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Inactive
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-120">Code</td>
                    <td className="text-nowrap">User</td>
                    <td className="text-nowrap">Email</td>
                    <td className="text-center text-nowrap wpx-110">Type</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                    <td className="text-center text-nowrap wpx-100">2FA</td>
                    <td
                      className="text-center text-nowrap wpx-110"
                      title="Mismatch approve over 3500 THB"
                    >
                      Mismatch AP
                    </td>
                    <td className="text-center text-nowrap users.update td-actions">
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={8} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No users found</div>
                          <div className="text-secondary text-14">
                            Try another search or create a new user.
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.map(this.renderRow)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New account" : "Edit account"}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : modal_update ? "Update" : ""} User
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {/* PROFILE */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Profile
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Name{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Full name"
                    onChange={(e) => {
                      this.setState({ full_name: e.target.value });
                    }}
                    value={full_name}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Phone{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="0812345678"
                    maxLength={10}
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ phone: e.target.value });
                    }}
                    value={phone}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Email{required}</label>
                  <input
                    type="email"
                    className="form-control pr-input"
                    placeholder="name@company.com"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                    disabled={modal_update}
                  />
                  {modal_update && (
                    <div className="pu-hint">
                      Email is the login identity and cannot be changed.
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ACCESS */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Access
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Role{required}</label>
                  <Select
                    className="form-control pr-input"
                    placeholder="Select role"
                    options={data_role?.map((item) => ({
                      value: item.uid,
                      label: item.name,
                    }))}
                    onChange={(v) => {
                      this.setState({
                        role_id: v,
                        user_type:
                          data_role?.find((item) => item.uid === v)?.name || "",
                        broker_id: "",
                      });
                    }}
                    value={role_id}
                    default={false}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">User Type{required}</label>
                  <Select
                    className="form-control pr-input"
                    placeholder="Select user type"
                    options={USER_TYPE_FORM_OPTIONS}
                    onChange={(v) => {
                      this.setState({
                        user_type: v,
                      });
                    }}
                    value={user_type}
                    default={false}
                  />
                </div>
                {showBroker && (
                  <div className="col-12">
                    <label className="pr-label">
                      Broker{user_type === "sub_broker" && required}
                    </label>
                    <Select
                      className="form-control pr-input"
                      placeholder="Select broker"
                      options={data_broker}
                      onChange={(e, i) => {
                        this.setState({ broker_id: e });
                      }}
                      value={broker_id}
                    ></Select>
                  </div>
                )}
                {showPassword && (
                  <div className="col-12">
                    <label className="pr-label">Password{required}</label>
                    <div className="pu-password">
                      <input
                        type="text"
                        className="form-control pr-input"
                        placeholder="Password"
                        onChange={(e) => {
                          this.setState({ password: e.target.value });
                        }}
                        value={password}
                      />
                      <button
                        type="button"
                        className="pu-generate"
                        title="Generate a random 12-character password"
                        onClick={() => {
                          const text = random_charactor(12);
                          this.setState({ password: text });
                        }}
                      >
                        <span className="icon me-2">{""}</span>Generate
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* SECURITY */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Security &amp; status
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-4">
                  {this.renderToggle({
                    icon: "",
                    title: "2FA Enable",
                    desc: "Require a one-time code at login",
                    checked: is_2fa,
                    onChange: (e) => this.setState({ is_2fa: e }),
                  })}
                </div>
                <div className="col-12 col-md-4">
                  {this.renderToggle({
                    icon: "",
                    title: "Mismatch approve",
                    desc: "Approve mismatch over 3,500 THB",
                    checked: is_mismatch_limit_approved,
                    onChange: (e) =>
                      this.setState({ is_mismatch_limit_approved: e }),
                  })}
                </div>
                <div className="col-12 col-md-4">
                  {this.renderToggle({
                    icon: "",
                    title: "Active",
                    desc: "Allow this account to sign in",
                    checked: is_active,
                    onChange: (e) => this.setState({ is_active: e }),
                  })}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer justify-content-between">
            <button
              type="button"
              className="pu-copy-btn"
              title="Copy username and password"
              onClick={() => {
                copyText(`username: ${email}
password: ${password}`);
              }}
            >
              <span className="icon me-2">{""}</span>Copy credentials
            </button>
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1 rounded-pill"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                onClick={this.closeModal}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
